import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, Container, Custom, DateTimePicker, Legend, Textbox } from "@app/shared";
import { formatDate, parseDate } from "ngx-bootstrap/chronos";

@Injectable()
export class ConsecutiveManagementFormService{
  constructor() { }

  /**
   * Configuración formulario para agregar o modificar una serie
   *
   * @param {SeriePredeterminada} [serie]
   * @returns {BaseControl<any>[]}
   * @memberof ConsecutiveManagementFormService
   */
  getFormConsecutive(objectModel?: any): BaseControl<any>[] {
    let consecutive = objectModel.consecutive;
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'consecutivo',
        type: 'number',
        class:{
          container: ['form-row col-lg-4 pl-1']
        },
        value: objectModel ? objectModel.data ? objectModel.data.consecutivo ? objectModel.data.consecutivo : consecutive : consecutive : consecutive,
        label: 'Consecutivo',
        placeholder: 'Consecutivo',
        order: 1,
        validations: {
          validators: [Validators.required, Validators.min(1)],
          messages: {
            min: 'El consecutivo debe ser un valor positivo'
          }
        }
      }),

      new Custom({
        key: 'dependencia',
        label: 'Dependencia',
        size: 'col-12 col-lg-6',
        placeholder: 'Selecciona la dependencia',
        template: objectModel.ngSelectTpl,
        // value: objectModel.dependency,
        options: objectModel.dependency,
        order: 2,
      }),
      new Container({
        class: 'form-row form-check form-check-inline',
        order: 3,
        controls: [
          new Textbox({
            key: 'reinicio',
            type: 'checkbox',
            label: 'Reinicio automático',
            class: {
              container: ['pl-1']
            },
            value: objectModel ? objectModel.data ? objectModel.data.reinicio ? objectModel.data.reinicio : null : null : null,
          })
        ]
      }),
      new Container({
        class: 'form-row',
        order: 4,
        key: 'date_container',
        controls: [
          new Textbox({
            key: 'dpicker2',
            type: 'number',
            label: 'Periodo de reinicio:',
            size: 'col-12 col-lg-4',
            customMin: 0,
            value: objectModel ? objectModel.data ? objectModel.data.periodicidad ? objectModel.data.periodicidad : null : null : null,
            placeholder: 'Ingrese la periodicidad',
            describe: 'Ingrese únicamente números.',
            validations: {
              validators: [Validators.required, Validators.min(1)],
              messages: {
                min: 'El valor mínimo seleccionado debe ser 1'
              }
            },
          }),
          new Custom({
            key: 'ngSelect',
            label: 'Tipo de periodicidad',
            order: 5,
            size: 'col-12 col-lg-6',
            template: objectModel.ngSelectTpl,
            value: objectModel ? objectModel.data ? objectModel.data.tipo_periodicidad ? objectModel.data.tipo_periodicidad : null : null : null,
            options: objectModel.list,
            placeholder: 'Seleccione la periodicidad',
            validations: {
              validators: [Validators.required]
            }
          })
        ]
      }),
      new DateTimePicker({
        // hidden: hidden,
        order: 6,
        key: 'dpicker3',
        label: 'Fecha de reinicio:',
        pickerMode: 'dialog',
        pickerType: 'calendar',
        maxDate: new Date(),
        class:{
          container: ['form-row col-lg-4 pl-1']
        },
        placeholder: 'Seleccione fecha de reinicio',
        value: objectModel ? objectModel.data ? objectModel.data.fecha_reinicio ? objectModel.data.fecha_reinicio : null : null : null,
        validations: {
          validators: [Validators.required]
        }
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

  /**
   * Configración formulario para agregar o modificar una serie
   *
   * @param {SeriePredeterminada} [serie]
   * @returns {BaseControl<any>[]}
   * @memberof ConsecutiveManagementFormService
   */
   getFormModal(objectModel?: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] =  [
      new Container({
        class: "form-row",
        order: 1,
        controls: [
          new Custom({
            key: 'serie',
            label: 'Serie',
            value: objectModel ? objectModel.data ? objectModel.data.serie ? objectModel.data.id_serie : null : null : null,
            size: 'col-12 col-lg-12',
            template: objectModel.serieTmplt,
            placeholder: 'Seleccione la serie',
            validations: {
              validators: [Validators.required]
            }
          }),
          new Custom({
            key: 'subserie',
            label: 'Subserie',
            size: 'col-12 col-lg-12',
            value: objectModel ? objectModel.data ? objectModel.data.subserie ? objectModel.data.id_subserie : null : null : null,
            template: objectModel.subserieTmpl,
            placeholder: 'Seleccione la subserie',
          }),
          new Custom({
            key: 'tipo_documental',
            label: 'Tipo documental',
            size: 'col-12 col-lg-12',
            value: objectModel ? objectModel.data ? objectModel.data.tipo_documental ? objectModel.data.id_tipo_documental : null : null : null,
            template: objectModel.typeDocTmpl,
            placeholder: 'Seleccione el tipo documental',
          })
        ],
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/documents/consecutive-management/shared/consecutive-management-form.service.ts